<template>
    <div>
        <AdminNavigation/>
        <CollapsableComponent :visible="true" id="viewItem" title="Pregled Blogova">
<!--            <component :is="viewItem"></component>-->
        </CollapsableComponent>
        <CollapsableComponent :visible="true" id="viewItem" title="Napravi Blog">
            <component :is="createBlog"></component>
        </CollapsableComponent>
        <CollapsableComponent :visible="true" id="viewItem" title="Promeni Blog">
<!--            <component :is="viewItem"></component>-->
        </CollapsableComponent>
        <CollapsableComponent :visible="true" id="viewItem" title="Obrisi Blog">
<!--            <component :is="viewItem"></component>-->
        </CollapsableComponent>
    </div>
</template>

<script>
import AdminNavigation from "@/component/admin/AdminNavigation.vue";
import CollapsableComponent from "@/component/common/CollapsableComponent.vue";
import AdminCreateBlog from "@/component/admin/blog/AdminCreateBlog.vue";

export default  {
        name: "BlogHome",
        components: {
            CollapsableComponent,
            AdminNavigation,
            createBlog: AdminCreateBlog
        },
        data() {
            return {
                createBlog: "createBlog"
            }
        }
    }
</script>


<style scoped>

</style>